/** Display form of a Backstage user ref: "user:default/jdoe" -> "jdoe". */
export function displayUser(value: string | null | undefined): string {
  if (!value) return '';
  return value.replace(/^user:[^/]+\//, '');
}

/**
 * Up-to-two-letter avatar initials from a user ref or email:
 * "user:default/akarshi.rastogi" / "akarshi.rastogi@kone.com" -> "AR".
 */
export function initials(value: string | null | undefined): string {
  const name = displayUser(value).split('@')[0];
  const letters = name
    .split(/[\s._-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0].toUpperCase())
    .join('');
  return letters || '?';
}

/** "approved" -> "Approved". */
export function capitalize(value: string): string {
  return value ? value.charAt(0).toUpperCase() + value.slice(1) : value;
}
